import { btnPrimary, btnSecondary, inputStyle, labelStyle } from "../shared";
import { PERMISSION_OPTIONS } from "./constants";

// ── Invite modal ──────────────────────────────────────────────────────────────
export function InviteModal({ newMember, setNewMember, addTeamMember, setShowAddMember }) {
  const cancel = () => {
    setShowAddMember(false);
    setNewMember({ email: "", name: "", role: "manager" });
  };

  return (
    <div style={{ position: "fixed", inset: 0, background: "#00000088", zIndex: 100, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ background: "#FFFFFF", border: "1px solid #E8E4DC", borderRadius: 16, padding: 32, width: 480, maxWidth: "95vw", boxShadow: "0 8px 32px rgba(0,0,0,0.12)", maxHeight: "90vh", overflowY: "auto" }}>
        <div style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 700, fontSize: 24, color: "#2B2B2B", marginBottom: 4 }}>Invite Team Member</div>
        <div style={{ fontSize: 13, color: "#9B9690", marginBottom: 24 }}>An email invite will be sent. They set their password when they accept.</div>

        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <div>
            <label style={labelStyle}>Email Address</label>
            <input type="email" value={newMember.email} onChange={e => setNewMember(s => ({ ...s, email: e.target.value }))} style={inputStyle} placeholder="team@example.com" autoFocus />
          </div>

          <div>
            <label style={labelStyle}>Permissions</label>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {PERMISSION_OPTIONS.map(opt => (
                <label key={opt.value} style={{ display: "flex", alignItems: "flex-start", gap: 10, padding: "10px 12px", border: `1.5px solid ${newMember.role === opt.value ? "#163C2F" : "#E8E4DC"}`, borderRadius: 8, cursor: "pointer", background: newMember.role === opt.value ? "#EAF2ED" : "#fff", transition: "all 0.12s" }}>
                  <input type="radio" name="permission" value={opt.value} checked={newMember.role === opt.value} onChange={() => setNewMember(s => ({ ...s, role: opt.value }))} style={{ marginTop: 2, accentColor: "#163C2F", flexShrink: 0 }} />
                  <div>
                    <div style={{ fontWeight: 700, fontSize: 13, color: "#163C2F" }}>{opt.label}</div>
                    <div style={{ fontSize: 12, color: "#9B9690", marginTop: 2 }}>{opt.desc}</div>
                  </div>
                </label>
              ))}
            </div>
          </div>
        </div>

        <div style={{ display: "flex", gap: 10, marginTop: 24, justifyContent: "flex-end" }}>
          <button onClick={cancel} style={btnSecondary}>Cancel</button>
          <button onClick={addTeamMember} style={btnPrimary}>Send Invite</button>
        </div>
      </div>
    </div>
  );
}
